import uiRouter from "@uirouter/angularjs";
import "angular-hotkeys";

import httpConfig from "./http.js";
import routeConfig from "./route.js";
import tooltipConfig from "./tooltip-provider.js";
import toastrConfig from "./toastr-config.js";
import datepickerConfig from "./datepicker-provider";
import datepickerPopupConfig from "./datepicker-popup-config";
import routeTransitionsConfig from "./route-transitions.js";
import { consoleShim } from "../services/console-shim.js";

const settings = getEnvironmentSettings();

consoleShim.shimConsole();

const buildDate = new Date().toISOString();

export const config = {
	...settings,
	buildDate,
	clientId: "vesl-web",
	support: {
		email: "support@vesldata.com",
		phone: {
			display: "(202) 883-8375",
			value: "2028838375"
		}
	}
};

export const uiState = {
	header: { searchToggled: false },
	sidebar: { open: false },
	environment: settings.environment
};

function getEnvironmentSettings() {

	// eslint-disable-next-line no-undef
	return ENVIRONMENT_CONFIGURATION;
}

const deps = [uiRouter, "cfp.hotkeys"];

export default angular
	.module("vesl.config", deps)
	.constant("config", config)
	.constant("uiState", uiState)
	.config(tooltipConfig)
	.config(datepickerConfig)
	.config(datepickerPopupConfig)
	.config(httpConfig)
	.config(routeConfig)
	.config(routeTransitionsConfig)
	.config(toastrConfig).name;
